import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=50012c84&"
import script from "./TableLoader.vue?vue&type=script&lang=ts&"
export * from "./TableLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports